export class UnprocessableContentError extends Error {
  constructor() {
    super()
    this.name = this.constructor.name
  }
}
